import { Component, OnInit } from '@angular/core';
import {ListeContact} from '../../../../../../model/liste/ListeContact';
import {ListeContactContact} from '../../../../../../model/liste/ListeContactContact';
import {ListeContactService} from '../../../../../../service/interne/contact/ListeContactService';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogueShareService} from '../../../../../../service/partage/utilitaire/DialogueShareService';
import {AuthShareService} from '../../../../../../service/partage/AuthShareService';
import {ListeParutionParution} from '../../../../../../model/liste/ListeParutionParution';

@Component({
  selector: 'app-escal-liste-contact-fiche-copier',
  templateUrl: './escal-liste-contact-fiche-copier.component.html',
  styleUrls: ['./escal-liste-contact-fiche-copier.component.scss'],
  providers: [ ListeContactService ]
})
export class EscalListeContactFicheCopierComponent implements OnInit {

  private sub: any;
  copier: boolean;
  listeContact: ListeContact;
  listeContactCopie: ListeContact;
  listeContactsAssocies: Array<ListeContactContact>;
  listeContactCopieId: number;
  constructor(private route: ActivatedRoute, private router: Router, private dialogueShareService: DialogueShareService,
              private listeContactService: ListeContactService, private authShareService: AuthShareService) { }

  ngOnInit() {
    this.listeContactCopie = new ListeContact(0, '', '', new Date(), null, this.authShareService.authUser,
      null, [], 0, []);
    this.copier = false;
    this.listeContactCopieId = 0;
    this.sub = this.route.params.subscribe(params => {
      this.listeContactService.getListeContactDetails(params.id)
        .then((listeContact) => {
          this.listeContact = listeContact as ListeContact;
          this.listeContactService.getAllAssosListeContact(this.listeContact.id).then(async (assosContacts) => {
            this.listeContactsAssocies = assosContacts['hydra:member'] as Array<ListeContactContact>;
            console.log(this.listeContactsAssocies);
          });
        });
    });
  }

  copierListeContact() {
    // copier liste
    let type;
    if (this.listeContact.type != null) {
      type = this.listeContact.type.id;
    } else {
      type = 0;
    }
    this.listeContactService.addListeContactCopie(this.listeContact, type).then(async listeContactCopie => {
      this.listeContactCopieId = listeContactCopie.id;
      // si contact(s) associé(s)
      await this.listeContactService.getAllAssosListeContact(this.listeContact.id).then(async (assosContacts) => {
        this.listeContactsAssocies = assosContacts['hydra:member'] as Array<ListeContactContact>;
        // pour chaque contact, on le récupère et on l'associe à la liste
        await this.listeContactsAssocies.forEach(asso => {
          this.listeContactService.addListeContactContact(asso.contact.id, listeContactCopie.id).then();
        });
        // enregistrer liste contact dans la base d'intranet
        await this.listeContactService.importerListeContactIntranet(listeContactCopie.id, 0).then(async (ancienIdListe) => {
          // insérer l'id d'intranet dans ancienId d'escalnet
          await this.listeContactService.addAncienIdListeContact(Number(ancienIdListe), listeContactCopie.id).then((retour) => {
            this.dialogueShareService.addDialogue('La liste a bien été copiée');
            this.copier = true;
          });
        });
      });
    });
  }

}
